module.exports = __webpack_public_path__ + "media/peach.309e7448.wav";